import * as categoriesActions from './actions';
import * as offersActions from '../offers/actions';
import * as loginActions from '../login/actions';
import * as tablesActions from '../tables/actions';
import * as stornoActions from '../storno/actions';
import * as creditActions from '../creditBill/actions';
import * as debtActions from '../menu/credit/debtDetail/actions';
import {List, fromJS, Map} from 'immutable';
import {Record} from '../transit';
import {
    countTotalItemsPrice, prepareOrderObject, countVatsItesPrices, mapVat, getNameByLang, printToKitchen,
    hasTablesProduct, prepareKitchenOrder, getKitchenItemsToPrint, containsKitchenItemsToPrint, isEnv,
    printToKitchenNew, isNeedArrayPrint, prepareKitchenPrintArray
} from '../lib/util';
import uuidFunf from 'uuid';
import * as barsActions from '../bars/actions';

const State = Record({
    categories: List(),
    choosedOfferCategories: List(),
    selectedCategoryId: 0,
    selectedProducts: Map(),
    layouts: Map(),
    markedProduct: null,
    markedProductTable: false,
    totalPriceVat: 0,
    lastKeyTime: null,
    lastNumKey: null,
    payingInProgress: false,
    waitingOrders: Map(),
    waitingOrdersSendToServerInProgress: false,
    lastBillNum: 0,
    organization: null,
    orderToPrint: null,
    onlineState: true,
    offerId: null,
    tables: Map(),
    showTableId: null,
    vats: Map(),
    tableLastState: null,
    itemsDivideFrom: Map(),
    itemsDivideTo: Map(),
    markedDivideItem: null,
    printingInProgress: false,
    tableToPrint: null,
    stornoNumber: null,
    sentBills: Map(),
    stornoReceipt: false,
    receiptToStorno: null,
    logo: null,
    countToDivide: 1,
    itemNames: Map(),
    itemColors: Map(),
    frequentlyItems: Map(),
    frequentlyItemsOffer: Map(),
    tableToCredit: null,
    maxTablePage: 5,
    countTablePage: 0,
    tablePage: 0,
    kitchenNumber: 0,
    kitchenToPrint: null,
    kitchenPrintDeviceSettings: false,
    kitchenPrintType: false,
    kitchenPrintLength: false,
    kitchenPrintAddress: false,
    kitchenItemsPrintSeparately: false,
    barName: ''
}, 'categories');

const BAR_NAME = 'barName';
const KITCHEN_PRINT_TYPE = 'kitchenPrintType';
const KITCHEN_PRINT_LENGTH = 'kitchenPrintLength';
const KITCHEN_PRINT_ADDRESS = 'kitchenPrintAddress';
const KITCHEN_PRINT_DEVICE_SETTINGS = 'kitchenPrintDeviceSettings';
const KITCHEN_TO_PRINT = 'kitchenToPrint';
const KITCHEN_NUMBER = 'kitchenNumber';
const KITCHEN_ITEMS_PRINT_SEPARATELY = 'kitchenItemsPrintSeparately';
const LAYOUTS = 'layouts';
const COUNT_TABLE_PAGE = 'countTablePage';
const MAX_TABLE_PAGE = 'maxTablePage';
const TABLE_PAGE = 'tablePage';
const FREQUENTLY_ITEMS = 'frequentlyItems';
const FREQUENTLY_ITEMS_OFFER = 'frequentlyItemsOffer';
const ITEM_NAMES = 'itemNames';
const ITEM_COLORS = 'itemColors';
const MARKED_DIVIDE_ITEM = 'markedDivideItem';
const ITEMS_DIVIDE_TO = 'itemsDivideTo';
const ITEMS_DIVIDE_FROM = 'itemsDivideFrom';
const LAST_BILL_NUM = 'lastBillNum';
const SELECTED_CATEGORY_ID = 'selectedCategoryId';
const CATEGORIES = 'categories';
const CHOOSED_OFFER_CATEGORIES = 'choosedOfferCategories';
const SELECTED_PRODUCTS = 'selectedProducts';
const MARKED_PRODUCT = 'markedProduct';
const MARKED_PRODUCT_TABLE = 'markedProductTable';
const TOTAL_PRICE_VAT = 'totalPriceVat';
const LAST_KEY_TIME = 'lastKeyTime';
const LAST_NUM_KEY = 'lastNumKey';
const PAYING_IN_PROGRESS = 'payingInProgress';
const PRINTING_IN_PROGRESS = 'printingInProgress';
const WAITING_ORDERS = 'waitingOrders';
const ONLINE_STATE = 'onlineState';
const ORDER_TO_PRINT = 'orderToPrint';
const TABLE_TO_PRINT = 'tableToPrint';
const ORGANIZATION = 'organization';
const LOGO = 'logo';
const OFFER_ID = 'offerId';
const TABLES = 'tables';
const SHOW_TABLE_UUID = 'showTableId';
const VATS = 'vats';
const TABLE_LAST_STATE = 'tableLastState';
const WAITING_ORDERS_SEND_TO_SERVER_IN_PROGRESS = 'waitingOrdersSendToServerInProgress';
const SENT_BILLS = 'sentBills';
const STORNO_RECEIPT = 'stornoReceipt';
const RECEIPT_TO_STORNO = 'receiptToStorno';
const COUNT_TO_DIVIDE = 'countToDivide';
const TABLE_TO_CREDIT = 'tableToCredit';

const categoriesReducer = (state = new State(), action) => {
    switch (action.type) {

        case barsActions.CHOOSE_BAR: {
            const bar = action.payload.bar;
            return state.set(BAR_NAME, !!bar ? bar.get('name') : '');
        }

        case debtActions.SET_DEBT_TO_PRINT: {
            const {bill} = action.payload;
            return state.set(ORDER_TO_PRINT, bill);
        }

        case categoriesActions.SET_KITCHEN_PRINT_DEVICE_SETTINGS: {
            const {name, value} = action.payload;
            return state.set(name, value);
        }

        case tablesActions.FETCH_LAYOUTS_START: {
            return state.set(LAYOUTS, Map());
        }

        case tablesActions.FETCH_LAYOUTS_SUCCESS: {
            const layouts = fromJS(action.payload.data);
            if (layouts.size > 0) {
                return state.set(LAYOUTS, layouts);
            } else {
                return addTableListFunc(state);
            }
        }

        case tablesActions.TABLE_PREV_PAGE: {
            const page = state.get(TABLE_PAGE) - 1;

            if (page >= 1) {
                return state.set(TABLE_PAGE, page);
            } else {
                return state.set(TABLE_PAGE, state.get(COUNT_TABLE_PAGE));
            }
        }

        case tablesActions.TABLE_NEXT_PAGE: {
            const tablesSize = state.get(COUNT_TABLE_PAGE);
            const page = state.get(TABLE_PAGE) + 1;

            if (page > tablesSize) {
                return state.set(TABLE_PAGE, 1);
            } else {
                return state.set(TABLE_PAGE, page);
            }
        }

        case tablesActions.SELECT_LAYOUT:
        case tablesActions.FETCH_LAYOUTS_ERROR:
        case tablesActions.ADD_TABLE_LIST: {
            return addTableListFunc(state, action.payload);
        }

        case tablesActions.REMOVE_TABLE_LIST: {
            const tablesSize = state.get(COUNT_TABLE_PAGE);
            const page = state.get(TABLE_PAGE);

            if (tablesSize > 0 && !hasTablesProduct(state.get(TABLES).filter(t => t.get('page') === page))) {
                let modState = state;
                const maxTablePage = modState.get(MAX_TABLE_PAGE);
                let tables = modState.get(TABLES);
                modState.get(TABLES).filter(t => t.get('page') === page).keySeq().forEach(k => {
                    tables = tables.delete(k);
                });
                modState = modState.set(TABLES, tables);

                // pokud jsem odebral z prostředka, je třeba doposunout listy aby nechyběla stránka
                if (page < tablesSize) {
                    let i = page;
                    // kontrola jestli je co přesunout
                    while (i < maxTablePage) {
                        const countPageTables = modState.get(TABLES).filter(t => t.get('page') === i + 1).size;
                        if (countPageTables > 0) {
                            modState = modState.update(TABLES, tables => tables.map(table => {
                                if (table.get('page') === i + 1) {
                                    return table.set('page', i);
                                } else {
                                    return table;
                                }
                            }));
                        }
                        i++;
                    }
                }

                let toPage = page;
                if (toPage > tablesSize - 1) {
                    toPage = toPage - 1;
                }

                return modState
                    .set(TABLE_PAGE, toPage)
                    .set(COUNT_TABLE_PAGE, tablesSize - 1);
            }

            return state;
        }

        case debtActions.FETCH_PAY_DEBT_SUCCESS: {
            return state.set(LAST_BILL_NUM, state.get(LAST_BILL_NUM) + 1);
        }

        case creditActions.OPEN_CREDIT_LIST_USERS: {
            const {tableId} = action.payload;
            return state.set(TABLE_TO_CREDIT, tableId);
        }

        case creditActions.DO_CREDIT_SUCCESS: {
            const newState = emptyTable(state.get(TABLE_TO_CREDIT), state);
            return newState.set(SELECTED_CATEGORY_ID, 0);
        }

        case categoriesActions.RECEIPT_LIST_MOVE: {
            const {id, isTable} = action.payload;
            const isTableBoolean = isTable === 'true';

            if (!id) {
                return state;
            } else {
                return state
                    .set(LAST_KEY_TIME, null)
                    .set(LAST_NUM_KEY, null)
                    .set(MARKED_PRODUCT, parseInt(id))
                    .set(MARKED_PRODUCT_TABLE, isTableBoolean);
            }
        }

        case tablesActions.DIVIDE_SET_PCS_KEYBOARD: {
            const {key} = action.payload;
            return changePcsKeyboardDivide(state, parseInt(key));
        }

        case tablesActions.DIVIDE_COUNT_INCREASE: {
            const pcs = parseFloat(state.get(COUNT_TO_DIVIDE));
            return pcs < 9999
                ? state.update(COUNT_TO_DIVIDE, pcs => parseFloat(pcs) + 1)
                : state;
        }

        case tablesActions.DIVIDE_COUNT_INCREASE_HALF: {
            return increaseProductHalfDivide(state);
        }

        case tablesActions.DIVIDE_COUNT_DECREASE: {
            const pcs = parseFloat(state.get(COUNT_TO_DIVIDE));
            return pcs > 1
                ? state.update(COUNT_TO_DIVIDE, pcs => parseFloat(pcs) - 1)
                : state;
        }

        case stornoActions.SELECT_RECEIPT_TO_STORNO_ONLINE: {
            const receipt = action.payload;
            return selectStornoReceiptOnline(state, receipt);
        }

        case stornoActions.SELECT_RECEIPT_TO_STORNO: {
            const id = action.payload;
            return selectStornoReceipt(state, id);
        }

        case loginActions.API_LOGOUT: {
            return state
                .set(ORDER_TO_PRINT, null)
                .set(CATEGORIES, List())
                .set(SELECTED_CATEGORY_ID, 0)
                .set(SELECTED_PRODUCTS, Map())
                .set(TOTAL_PRICE_VAT, 0)
                .set(OFFER_ID, null)
                .set(TABLE_LAST_STATE, null)
                .set(LOGO, null)
                .set(ORGANIZATION, null);
        }

        case categoriesActions.SEND_WAITING_ORDERS_START: {
            return state.set(WAITING_ORDERS_SEND_TO_SERVER_IN_PROGRESS, true);
        }

        case categoriesActions.SEND_WAITING_ORDERS_SUCCESS: {
            const listIds = fromJS(action.payload.data);
            let newState = state;
            listIds.forEach(id => {
                newState = newState.update(WAITING_ORDERS, orders => orders.remove(parseInt(id)));
            });

            return newState
                .set(WAITING_ORDERS_SEND_TO_SERVER_IN_PROGRESS, false);
        }

        case categoriesActions.WAITING_ORDERS_SET_NOT_IN_PROGRESS:
        case categoriesActions.SEND_WAITING_ORDERS_ERROR: {
            return state.set(WAITING_ORDERS_SEND_TO_SERVER_IN_PROGRESS, false);
        }

        case tablesActions.TABLE_MERGE: {
            const {uuid, msg} = action.payload;

            const lastTableState = !!state.get(TABLE_LAST_STATE) ? state.get(TABLE_LAST_STATE) : state.getIn([TABLES, uuid, 'products']);
            let newState = chooseProductsToFavourite(uuid, state);
            newState = newState.setIn([TABLES, uuid, 'products'], mergeProducts(uuid, newState));
            if (isEnv(['android_app', 'electron']) && ( newState.get(KITCHEN_PRINT_DEVICE_SETTINGS) || newState.get(KITCHEN_PRINT_TYPE) !== 'off') ) {
                newState = mergeProductsToKitchen(uuid, newState, lastTableState, msg);
            }
            newState = newState
                .setIn([TABLES, uuid, 'lastAccess'], new Date().getTime())
                .set(SELECTED_PRODUCTS, Map())
                .set(TOTAL_PRICE_VAT, 0)
                .set(TABLE_LAST_STATE, null);

            return countTableTotalPrice(uuid, newState);
        }

        case tablesActions.ADD_TO_TABLE: {
            const id = action.payload;

            let newState = mergeDivideProductsToExistsTable(id, state);
            newState = newState
                .setIn([TABLES, id, 'lastAccess'], new Date().getTime())
                .set(SELECTED_CATEGORY_ID, 0)
                .set(SELECTED_PRODUCTS, Map());

            return showTable(newState, id);
        }

        case tablesActions.TABLE_SAVE: {
            const {uuid, msg} = action.payload;

            const lastTableState = !!state.get(TABLE_LAST_STATE) ? state.get(TABLE_LAST_STATE) : state.getIn([TABLES, uuid, 'products']);
            let newState = chooseProductsToFavourite(uuid, state);
            newState = newState.setIn([TABLES, uuid, 'products'], mergeProducts(uuid, newState));
            if (isEnv(['android_app', 'electron']) && ( newState.get(KITCHEN_PRINT_DEVICE_SETTINGS) || newState.get(KITCHEN_PRINT_TYPE) !== 'off') ) {
                newState = mergeProductsToKitchen(uuid, newState, lastTableState, msg);
            }
            newState = newState
                .setIn([TABLES, uuid, 'lastAccess'], new Date().getTime())
                .set(SELECTED_CATEGORY_ID, 0)
                .set(SELECTED_PRODUCTS, Map())
                .set(TOTAL_PRICE_VAT, 0)
                .set(SHOW_TABLE_UUID, null)
                .set(TABLE_LAST_STATE, null);

            return countTableTotalPrice(uuid, newState);
        }

        case tablesActions.SHOW_TABLE: {
            const uuid = action.payload;
            return showTable(state, uuid);
        }

        case tablesActions.CLOSE_SHOW_TABLE: {
            const tableUuid = state.get(SHOW_TABLE_UUID);
            let newState = state
                .setIn([TABLES, tableUuid, 'products'], state.get(TABLE_LAST_STATE))
                .set(TABLE_LAST_STATE, null)
                .set(MARKED_PRODUCT_TABLE, false)
                .set(MARKED_PRODUCT, null)
                .set(SELECTED_CATEGORY_ID, 0)
                .set(SHOW_TABLE_UUID, null);

            return countTableTotalPrice(tableUuid, newState);
        }

        case tablesActions.DELETE_TABLE: {
            const uuid = action.payload;
            const newState = emptyTable(uuid, state);
            return newState.set(SELECTED_CATEGORY_ID, 0);
        }

        case tablesActions.OPEN_TABLE: {
            const {uuid, name, msg} = action.payload;

            if (!!state.get(SHOW_TABLE_UUID)) {
                return manageDivideTables(state, uuid, name, msg);
            } else {
                return openTable(state, uuid, name, state.get(SELECTED_PRODUCTS), true, msg);
            }
        }

        case offersActions.CHOOSE_OFFER: {
            return state
                .set(OFFER_ID, action.payload)
                .set(SELECTED_CATEGORY_ID, 0);
        }

        case stornoActions.SELECT_RECEIPT_TO_PRINT_ONLINE: {
            return state
                .set(ORDER_TO_PRINT, action.payload)
                .set(PRINTING_IN_PROGRESS, true)
                .set(PAYING_IN_PROGRESS, true);
        }

        case stornoActions.SELECT_RECEIPT_TO_SHOW_ONLINE: {
            return state.set(ORDER_TO_PRINT, action.payload);
        }

        case stornoActions.SELECT_RECEIPT_TO_SHOW: {
            const number = action.payload;
            return state.set(ORDER_TO_PRINT, state.getIn([SENT_BILLS, parseInt(number)]));
        }

        case stornoActions.SELECT_RECEIPT_TO_PRINT: {
            const number = action.payload;
            return state
                .set(ORDER_TO_PRINT, state.getIn([SENT_BILLS, parseInt(number)]))
                .set(PRINTING_IN_PROGRESS, true)
                .set(PAYING_IN_PROGRESS, true);
        }

        case categoriesActions.SET_FORBID_SALE: {
            return state
                .set(PRINTING_IN_PROGRESS, true)
                .set(PAYING_IN_PROGRESS, true);
        }

        case categoriesActions.SET_ALLOW_SALE: {
            return state
                .set(PRINTING_IN_PROGRESS, false)
                .set(PAYING_IN_PROGRESS, false);
        }

        case categoriesActions.ONLINE_CHECK_ERROR:
        case categoriesActions.SET_STATE_OFFLINE: {
            return state.set(ONLINE_STATE, false);
        }

        case categoriesActions.ONLINE_CHECK_SUCCESS:
        case categoriesActions.SET_STATE_ONLINE: {
            return state.set(ONLINE_STATE, true);
        }

        case categoriesActions.SET_CATEGORY: {
            return state.set(SELECTED_CATEGORY_ID, parseInt(action.payload))
        }

        case categoriesActions.CLEAR_RECEIPT: {
            return state
                .set(SELECTED_PRODUCTS, Map())
                .set(MARKED_PRODUCT, null)
                .set(LAST_KEY_TIME, null)
                .set(LAST_NUM_KEY, null)
                .set(TOTAL_PRICE_VAT, 0);
        }

        case categoriesActions.SET_PCS_KEYBOARD: {
            return changePcsKeyboard(state, parseInt(action.payload));
        }

        case categoriesActions.SELECT_PRODUCT: {
            const id = parseInt(action.payload);
            const isInArray = !!state.getIn([SELECTED_PRODUCTS, id]);
            const newState = state
                .set(LAST_KEY_TIME, null)
                .set(LAST_NUM_KEY, null)
                .set(TOTAL_PRICE_VAT, 0)
                .set(MARKED_PRODUCT_TABLE, false)
                .set(MARKED_PRODUCT, id);

            return isInArray
                ? increaseProduct(newState, id)
                : addProductToList(newState, id);
        }

        case categoriesActions.INCREASE_PRODUCT: {
            const newState = state
                .set(LAST_NUM_KEY, null)
                .set(LAST_KEY_TIME, null);
            return increaseProduct(newState, action.payload)
        }

        case categoriesActions.INCREASE_PRODUCT_HALF: {
            return increaseProductHalf(state, action.payload);
        }

        case categoriesActions.DECREASE_PRODUCT: {
            const newState = state
                .set(LAST_NUM_KEY, null)
                .set(LAST_KEY_TIME, null);
            return decreaseProduct(newState, action.payload)
        }

        case categoriesActions.MARK_PRODUCT: {
            const {id, isTable} = action.payload;
            return state
                .set(LAST_KEY_TIME, null)
                .set(LAST_NUM_KEY, null)
                .set(MARKED_PRODUCT_TABLE, isTable)
                .set(MARKED_PRODUCT, id);
        }
        case categoriesActions.FETCH_INIT_APP_START: {
            if (!!state.get(TABLES).has(1)) {
                function createTable(table, uuid) {
                    return Map({
                        position: table.get('id'),
                        uuid: uuid,
                        page: 1,
                        name: table.get('name'),
                        lastAccess: table.get('lastAccess'),
                        open: table.get('open'),
                        products: table.get('products'),
                        totalPriceVat: table.get('totalPriceVat'),
                        totalPrices: table.get('totalPrices')
                    });
                }

                let tables = Map();
                state.get(TABLES).sortBy(t => t.get('id')).forEach(table => {
                    const uuid = uuidFunf();
                    tables = tables.set(uuid, createTable(table, uuid));
                });

                return state.set(TABLES, tables);
            }
            return state;
        }
        case categoriesActions.FETCH_INIT_APP_SUCCESS: {
            const {deviceFavourite, categories, organization, vats, logo} = action.payload.data;

            let vatsMap = Map();
            vats.map(vat => {
                vatsMap = vatsMap.set(vat.id, mapVat(vat));
            });

            const cat = fromJS(categories);
            const selectedOfferCategories = cat.filter(c => c.get('offerId') === state.get(OFFER_ID));
            const favouriteItems = manageFavouriteItems(fromJS(deviceFavourite));

            return state
                .set(FREQUENTLY_ITEMS, favouriteItems)
                .set(FREQUENTLY_ITEMS_OFFER, manageFavouriteItemsOffer(favouriteItems, selectedOfferCategories, state.get(OFFER_ID)))
                .set(ITEM_NAMES, manageItemNames(cat))
                .set(ITEM_COLORS, manageItemColors(cat))
                .set(ORGANIZATION, fromJS(organization))
                .set(LOGO, logo)
                .set(VATS, vatsMap)
                .set(CATEGORIES, cat)
                .set(CHOOSED_OFFER_CATEGORIES, selectedOfferCategories);
        }


        case categoriesActions.FETCH_ONLY_CATEGORIES_ERROR: {
            const selectedOfferCategories = state.get(CATEGORIES).filter(c => c.get('offerId') === state.get(OFFER_ID));

            return state
                .set(SELECTED_PRODUCTS, Map())
                .set(TOTAL_PRICE_VAT, 0)
                .set(CHOOSED_OFFER_CATEGORIES, selectedOfferCategories)
                .set(FREQUENTLY_ITEMS_OFFER, manageFavouriteItemsOffer(state.get(FREQUENTLY_ITEMS), selectedOfferCategories, state.get(OFFER_ID)));
        }

        case categoriesActions.FETCH_ONLY_CATEGORIES_SUCCESS: {
            const {categories, deviceFavourite} = action.payload.data;
            const cats = List(fromJS(categories));
            const selectedOfferCategories = cats.filter(c => c.get('offerId') === state.get(OFFER_ID));
            const favouriteItems = manageFavouriteItems(fromJS(deviceFavourite));

            return state
                .set(ITEM_NAMES, manageItemNames(cats))
                .set(ITEM_COLORS, manageItemColors(cats))
                .set(FREQUENTLY_ITEMS_OFFER, manageFavouriteItemsOffer(favouriteItems, selectedOfferCategories, state.get(OFFER_ID)))
                .set(SELECTED_PRODUCTS, Map())
                .set(TOTAL_PRICE_VAT, 0)
                .update(CATEGORIES, ctgs => ctgs.merge(cats))
                .set(CHOOSED_OFFER_CATEGORIES, selectedOfferCategories);
        }

        case categoriesActions.PAY_ORDER_START: {
            const {isTable, data, vats, containsKitchenItems, kitchenPrint} = action.payload.data;
            const {
                branchId, items, discount, takeaway, paymentType, cashboxId, deviceId, barId, number, sellTime,
                storno, sellerId
            } = action.payload.data.data;

            let newState = state;
            if (!!isTable) {
                newState = managePayDivideTable(newState, number, barId, cashboxId, takeaway, discount, branchId,
                                                paymentType, sellTime, data.note, sellerId, items, vats);
            } else {
                newState = increaseFavourite(newState, items);
                newState = newState.set(ORDER_TO_PRINT,
                    createOrderToMap(newState, number, barId, cashboxId, takeaway, discount, branchId,
                                        paymentType, sellTime, storno, sellerId, items, vats));
            }

            if (!!storno) {
                newState = newState
                    .set(STORNO_RECEIPT, false)
                    .set(RECEIPT_TO_STORNO, null);
            } else {
                newState = addReceiptToSentBills(newState);
            }

            if (typeof window.parent.Ocellot !== 'undefined' && typeof window.parent.Ocellot.printEscpos === 'function') {
                if (!isTable && !storno && containsKitchenItems && newState.get(KITCHEN_PRINT_TYPE) !== 'off') {
                    newState = newState.set(KITCHEN_NUMBER, newState.get(KITCHEN_NUMBER) + 1);
                    const itemsToKitchen = getKitchenItemsToPrint(newState.get(ORDER_TO_PRINT).get('selectedProducts'));
                    newState = newState.set(KITCHEN_TO_PRINT, prepareKitchenOrder(newState.get(KITCHEN_NUMBER), itemsToKitchen, false));
                    newState = newState.setIn([ORDER_TO_PRINT, 'kitchenNumber'], newState.get(KITCHEN_NUMBER));
                }
            } else if (!isTable && !storno && containsKitchenItems && kitchenPrint) {
                newState = newState.set(KITCHEN_NUMBER, newState.get(KITCHEN_NUMBER) + 1);
                const itemsToKitchen = getKitchenItemsToPrint(newState.get(ORDER_TO_PRINT).get('selectedProducts'));
                newState = newState.set(KITCHEN_TO_PRINT, prepareKitchenOrder(newState.get(KITCHEN_NUMBER), itemsToKitchen, false));
                newState = newState.setIn([ORDER_TO_PRINT, 'kitchenNumber'], newState.get(KITCHEN_NUMBER));
            }


            return newState
                .update(WAITING_ORDERS, orders =>
                    orders.set(newState.getIn([ORDER_TO_PRINT, 'number']), newState.get(ORDER_TO_PRINT)))
                .set(PRINTING_IN_PROGRESS, true)
                .set(PAYING_IN_PROGRESS, true)
                .set(MARKED_PRODUCT, null)
                .set(LAST_KEY_TIME, null)
                .set(LAST_NUM_KEY, null)
                .set(SELECTED_PRODUCTS, Map())
                .set(SELECTED_CATEGORY_ID, 0)
                .set(TOTAL_PRICE_VAT, 0)
                .set(PRINTING_IN_PROGRESS, true)
                .set(PAYING_IN_PROGRESS, true)
                .set(SHOW_TABLE_UUID, null)
                .set(LAST_BILL_NUM, number);
        }

        case tablesActions.CLOSE_TABLE_TO_PRINT: {
            return state
                .set(TABLE_TO_PRINT, null)
                .set(PRINTING_IN_PROGRESS, false)
                .set(PAYING_IN_PROGRESS, false);
        }

        case tablesActions.PREPARE_TABLE_TO_PRINT: {
            return state
                .set(PRINTING_IN_PROGRESS, true)
                .set(PAYING_IN_PROGRESS, true)
                .set(TABLE_TO_PRINT, prepareTableToPrint(state, action.payload))
        }

        case categoriesActions.PAY_ORDER_SUCCESS: {
            const newState = addEet(state, action.payload.data);
            return newState
                .update(WAITING_ORDERS, orders => orders.remove(newState.getIn([ORDER_TO_PRINT, 'number'])));
        }

        case tablesActions.DIVIDE_REMOVE_ALL:
        case tablesActions.OPEN_DIVIDE_TABLE: {
            return state
                .set(ITEMS_DIVIDE_FROM, state.getIn([TABLES, state.get(SHOW_TABLE_UUID), 'products']))
                .set(ITEMS_DIVIDE_TO, Map());
        }

        case tablesActions.CLOSE_DIVIDE_TABLE: {
            return clearDivedeLists(state);

        }

        case tablesActions.DIVIDE_PAY_ALL: {
            return state
                .set(ITEMS_DIVIDE_FROM, Map())
                .set(ITEMS_DIVIDE_TO, state.getIn([TABLES, state.get(SHOW_TABLE_UUID), 'products']));
        }

        case tablesActions.MARK_DIVIDE_ITEM: {
            if (!action.payload) {
                return state;
            }
            return state.set(MARKED_DIVIDE_ITEM, action.payload);
        }

        case tablesActions.DIVIDE_MOVE_FROM_TO: {
            return divideMoveFromTo(state);
        }

        case tablesActions.DIVIDE_MOVE_TO_FROM: {
            return divideMoveToFrom(state);
        }

    }
    return state;
};

export default categoriesReducer;

function increaseFavourite(s, items) {
    let state = s;

    items.forEach(item => {
        const itemId = item.get('id');

        if (state.get(FREQUENTLY_ITEMS_OFFER).has(itemId)) {
            state = state.updateIn([FREQUENTLY_ITEMS_OFFER, itemId], val => val + 1);
        } else {
            state = state.update(FREQUENTLY_ITEMS_OFFER, fItems => fItems.set(itemId, 1));
        }

        if (state.get(FREQUENTLY_ITEMS).has(itemId)) {
            state = state.updateIn([FREQUENTLY_ITEMS, itemId], val => val + 1);
        } else {
            state = state.update(FREQUENTLY_ITEMS, fItems => fItems.set(itemId, 1));
        }

    });

    return state;
}

function manageFavouriteItems(favourite) {
    let map = Map();
    favourite.forEach((val, key) => {
        map = map.set(parseInt(key), parseInt(val));
    });
    return map;
}

function manageFavouriteItemsOffer(favouriteItems, categories, offerId) {
    let map = Map();
    let items = categories.filter(cat => cat.get('offerId') === offerId)
        .flatMap(cat => cat.get('items')).map(item => item.get('id'));

    favouriteItems.filter((val, key) => items.indexOf(key) > -1).forEach((val, key) => {
        map = map.set(key, val);
    });

    return map;
}

function manageItemNames(categories) {
    let map = Map();
    categories.flatMap(cat => cat.get('items')).forEach(i => {
        map = map.set(i.get('id'), getNameByLang(i));
    });
    return map;
}

function manageItemColors(categories) {
    let map = Map();
    categories.flatMap(cat => cat.get('items')).forEach(i => {
        map = map.set(i.get('id'), Map({backgroundColor: i.getIn(['color', 'backgroundColor']), textColor: i.getIn(['color', 'textColor'])}));
    });
    return map;
}

function prepareTableToPrint(state, isInformative) {
    const products = mergeProducts(state.get(SHOW_TABLE_UUID), state);

    return Map({
        selectedProducts: products,
        totalPriceVat: countTotalItemsPrice(products),
        totalPrices: countVatsItesPrices(state.get(VATS), products),
        time: Date.now(),
        number: 0,
        eet: null,
        name: state.getIn([TABLES, state.get(SHOW_TABLE_UUID), 'name']),
        isInformative: isInformative
    });
}

function manageDivideTables(state, uuid, name, msg) {
    let newState = openTable(state, uuid, name, state.get(ITEMS_DIVIDE_TO), false, msg);
    newState = manageFromList(newState);
    return clearDivedeLists(newState);
}

function manageFromList(state) {
    const tableUuid = state.get(SHOW_TABLE_UUID);
    const itemsFrom = state.get(ITEMS_DIVIDE_FROM);
    if (itemsFrom.size > 0) {
        let newState = state.updateIn([TABLES, tableUuid, 'products'], products => itemsFrom);
        return countTableTotalPrice(tableUuid, newState);
    } else {
        return emptyTable(tableUuid, state);
    }
}

function openTable(state, uuid, name, products, print, msg) {
    let newState = state
        .setIn([TABLES, uuid, 'name'], name)
        .setIn([TABLES, uuid, 'open'], true)
        .setIn([TABLES, uuid, 'products'], products)
        .setIn([TABLES, uuid, 'lastAccess'], new Date().getTime())
        .set(SELECTED_PRODUCTS, Map())
        .set(TOTAL_PRICE_VAT, 0)
        .set(SELECTED_CATEGORY_ID, 0);

    if (!!products) {
        if (products.size === 0) {
            newState = showTable(newState, uuid);
        } else {
            newState = increaseFavourite(newState, products);
            if (isEnv(['android_app', 'electron']) && print && ( newState.get(KITCHEN_PRINT_DEVICE_SETTINGS) || newState.get(KITCHEN_PRINT_TYPE) !== 'off' ) && containsKitchenItemsToPrint(products)) {
                newState = newState.set(KITCHEN_NUMBER, newState.get(KITCHEN_NUMBER) + 1);
                newState = newState.set(KITCHEN_TO_PRINT, prepareKitchenOrder(newState.get(KITCHEN_NUMBER), getKitchenItemsToPrint(products), name));
                if (typeof window.parent.Ocellot !== 'undefined' && typeof window.parent.Ocellot.printEscpos === 'function') {
                    const printArrayKitchen = !!isNeedArrayPrint(newState.get(KITCHEN_PRINT_TYPE))
                        ? prepareKitchenPrintArray(newState.get(BAR_NAME), newState.get(KITCHEN_TO_PRINT), newState.get(KITCHEN_ITEMS_PRINT_SEPARATELY), msg)
                        : null;
                    printToKitchenNew(true, newState.get(KITCHEN_PRINT_TYPE), newState.get(KITCHEN_PRINT_ADDRESS), printArrayKitchen, newState.get(KITCHEN_PRINT_LENGTH));
                } else {
                    printToKitchen(true);
                }
            }
        }
    }

    return countTableTotalPrice(uuid, newState);
}

function clearDivedeLists(state) {
    return state
        .set(ITEMS_DIVIDE_FROM, Map())
        .set(ITEMS_DIVIDE_TO, Map())
        .set(SHOW_TABLE_UUID, null)
        .set(MARKED_DIVIDE_ITEM, null);
}

function changePcsKeyboardDivide(state, key) {
    let newPcs = parseFloat(state.get(COUNT_TO_DIVIDE));
    if (lastKeyTimeout(state)) {
        newPcs = parseFloat(key);
    } else if (newPcs.toString().length < 4) {
        newPcs = parseFloat(`${newPcs}${key}`);
    } else if (newPcs.toString().indexOf('.') > -1) {
        newPcs = parseFloat(`${key}`);
    }

    return state
        .set(COUNT_TO_DIVIDE, newPcs)
        .set(LAST_KEY_TIME, new Date().getTime());
}

function divideMoveToFrom(state) {
    return moveDivideProducts(state, ITEMS_DIVIDE_TO, ITEMS_DIVIDE_FROM, state.get(COUNT_TO_DIVIDE));
}

function divideMoveFromTo(state) {
    return moveDivideProducts(state, ITEMS_DIVIDE_FROM, ITEMS_DIVIDE_TO, state.get(COUNT_TO_DIVIDE));
}

function moveDivideProducts(state, from, to, amount) {
    const itemId = state.get(MARKED_DIVIDE_ITEM);
    if (!itemId) {
        return state;
    }

    const amountInList = state.getIn([from, itemId, 'pcs']);
    let realMoveAmount;
    if (amount > amountInList) {
        realMoveAmount = amountInList;
    } else {
        realMoveAmount = amount;
    }

    if (state.get(to).has(itemId)) {
        //pokud položka je na seznamu, přidáme počet
        state = state.updateIn([to, itemId, 'pcs'], pcs => pcs + realMoveAmount);
    } else {
        //pokud položka na seznamu neexistuje, je třeba jí založit a přidat jí přesouvané množství
        state = state.update(to, map => map.set(itemId, state.getIn([from, itemId])));
        state = state.updateIn([to, itemId, 'pcs'], pcs => realMoveAmount);
    }
    //odebereme ze zdrojového seznamu počet přesouvaného množství
    state = state.updateIn([from, itemId, 'pcs'], pcs => pcs - realMoveAmount);


    state = removeFromDivide(from, itemId, state);

    return resetCountToDivide(state);
}

/**
 * odebítání pokud je 0 a méně položek na seznamu
 *
 * @param from
 * @param itemId
 * @param state
 * @returns {*}
 */
function removeFromDivide(from, itemId, state) {
    let selectedId = null;

    if (state.getIn([from, itemId, 'pcs']) <= 0) {
        const items = state.get(from);
        const item = items.get(itemId);
        if (!!item && items.size > 1) {
            const larger = items.filter(mi => mi.get('addTime') > item.get('addTime'));
            if (larger.size > 0) {
                selectedId = larger.sortBy(item => item.get('addTime')).first().get('id');
            } else {
                const smaller = items.filter(mi => mi.get('addTime') < item.get('addTime'));
                if (smaller.size > 0) {
                    selectedId = smaller.sortBy(item => item.get('addTime')).reverse().first().get('id');
                }
            }
        }
        state = state.update(from, map => map.remove(itemId));
    } else {
        selectedId = itemId;
    }
    return state.set(MARKED_DIVIDE_ITEM, selectedId);
}

function generateTables(page, layout) {
    const maxTables = !!layout ? layout.get('width') * layout.get('height') : 9 * 7;

    let tables = Map();
    for (let i = 1; i <= maxTables; i++) {
        const uuid = uuidFunf();
        const layoutTable = !!layout && !!layout.get('tablesMap') && layout.get('tablesMap').has(i.toString()) ? layout.get('tablesMap').get(i.toString()) : null;
        tables = tables.set(uuid, createTable(i, uuid, page, layoutTable));
    }
    return tables;
}

function mergeDivideProductsToExistsTable(id, state) {
    let tableProducts = state.getIn([TABLES, id, 'products']);
    const nonTableProducts = state.get(ITEMS_DIVIDE_TO);

    nonTableProducts.forEach(p => {
        if (tableProducts.has(p.get('id'))) {
            tableProducts = tableProducts.updateIn([p.get('id'), 'pcs'], pcs => pcs + p.get('pcs'))
        } else {
            tableProducts = tableProducts.set(p.get('id'), p);
        }
    });

    let newState = state.setIn([TABLES, id, 'products'], tableProducts);
    newState = manageFromList(newState);
    newState = countTableTotalPrice(id, newState);
    return clearDivedeLists(newState);
}

function chooseProductsToFavourite(uuid, state) {
    let tableProducts = state.getIn([TABLES, uuid, 'products']);
    const nonTableProducts = state.get(SELECTED_PRODUCTS);
    let productToFavourite = Map();

    nonTableProducts.forEach(p => {
        if (!tableProducts.has(p.get('id'))) {
            productToFavourite = productToFavourite.set(p.get('id'), p);
        }
    });

    return increaseFavourite(state, productToFavourite);
}

function mergeProductsToKitchen(uuid, state, lastTableState, msg) {
    let updatedTableState = state.getIn([TABLES, uuid, 'products']);
    if (containsKitchenItemsToPrint(updatedTableState)) {
        let map = Map();
        if (!!lastTableState) {
            updatedTableState.forEach(p => {
                if (lastTableState.has(p.get('id'))) {
                    const lastPcs = lastTableState.getIn([p.get('id'), 'pcs']);
                    const nowPcs = p.get('pcs');
                    if (nowPcs > lastPcs) {
                        map = map.set(p.get('id'), p);
                        map = map.setIn([p.get('id'), 'pcs'], nowPcs - lastPcs);
                    }
                } else {
                    map = map.set(p.get('id'), p);
                }
            });
        }

        if (isEnv(['android_app', 'electron'])) {
            if (containsKitchenItemsToPrint(map)) {
                state = state.set(KITCHEN_NUMBER, state.get(KITCHEN_NUMBER) + 1);
                state = state.set(KITCHEN_TO_PRINT, prepareKitchenOrder(state.get(KITCHEN_NUMBER), getKitchenItemsToPrint(map), state.getIn([TABLES, uuid, 'name'])));
                if (typeof window.parent.Ocellot !== 'undefined' && typeof window.parent.Ocellot.printEscpos === 'function') {
                    const printArrayKitchen = !!isNeedArrayPrint(state.get(KITCHEN_PRINT_TYPE))
                        ? prepareKitchenPrintArray(state.get(BAR_NAME), state.get(KITCHEN_TO_PRINT), state.get(KITCHEN_ITEMS_PRINT_SEPARATELY), msg)
                        : null;
                    printToKitchenNew(true, state.get(KITCHEN_PRINT_TYPE), state.get(KITCHEN_PRINT_ADDRESS), printArrayKitchen, state.get(KITCHEN_PRINT_LENGTH));
                } else {
                    printToKitchen(true);
                }
            }
        }
    }

    return state;
}

function mergeProducts(uuid, state) {
    let tableProducts = state.getIn([TABLES, uuid, 'products']);
    const nonTableProducts = state.get(SELECTED_PRODUCTS);

    nonTableProducts.forEach(p => {
        if (tableProducts.has(p.get('id'))) {
            tableProducts = tableProducts.updateIn([p.get('id'), 'pcs'], pcs => pcs + p.get('pcs'))
        } else {
            tableProducts = tableProducts.set(p.get('id'), p);
        }
    });

    return tableProducts;
}

function createTable(position, uuid, page, layoutTable) {
    return Map({
        stable: !!layoutTable,
        position: position,
        page: page,
        uuid: uuid,
        name: !!layoutTable ? layoutTable.get('name') : '',
        lastAccess: new Date().getTime(),
        open: !!layoutTable,
        products: Map(),
        totalPriceVat: 0,
        totalPrices: Map()
    });
}

function lastKeyTimeout(state) {
    const lastKeyTime = state.get(LAST_KEY_TIME);
    return lastKeyTime === null || ((lastKeyTime + 1500) < new Date().getTime())
}

function changePcsKeyboard(state, key) {
    if (!canBeEdited(state)) {
        return state;
    }
    const route = getProductsPcsRoute(state);

    const id = state.get(MARKED_PRODUCT);
    let newPcs = state.getIn(route);

    if (lastKeyTimeout(state)) {
        if (key === 0) {
            return countTotalPriceSwitch(removeProduct(state, id));
        } else {
            newPcs = key;
        }
    } else if (newPcs.toString().length < 4) {
        newPcs = parseFloat(`${newPcs}${key}`);
    } else if (newPcs.toString().indexOf('.') > -1) {
        newPcs = parseFloat(`${key}`);
    }

    const newState = state
        .setIn(route, newPcs)
        .set(LAST_NUM_KEY, key)
        .set(LAST_KEY_TIME, new Date().getTime());

    return countTotalPriceSwitch(newState);
}

function addProductToList(state, id) {
    let product;
    state.get(CATEGORIES).map(cat => {
        cat.get('items').filter(i => i.get('id') === id).map(i => {
            product = i;
        })
    });

    const newState = state.update(SELECTED_PRODUCTS, products => products.set(parseInt(id), Map({
        id: parseInt(id),
        pcs: 1,
        name: !!product.getIn(['names', 'CS', 'name'])
            ? product.getIn(['names', 'CS', 'name'])
            : product.getIn(['names', 'EN', 'name']),
        price: parseFloat(product.getIn(['prices', 'CZK', 'amount'])),
        discount: 0,
        vatId: product.get('vatId'),
        kitchen: product.get('kitchen'),
        addTime: new Date().getTime()
    })));

    return countTotalPrice(newState);
}

function addEet(state, data) {
    if (typeof data === 'object') {
        return state.updateIn([ORDER_TO_PRINT, 'eet'], eet => fromJS(data));
    }
    return state;
}

function emptyTable(uuid, state) {
    let modState = state
        .set(TABLE_LAST_STATE, null)
        .setIn([TABLES, uuid, 'lastAccess'], 0)
        .setIn([TABLES, uuid, 'totalPriceVat'], 0)
        .setIn([TABLES, uuid, 'products'], Map())
        .setIn([TABLES, uuid, 'totalPrices'], Map())
        .set(SHOW_TABLE_UUID, null);

    if (!modState.getIn([TABLES, uuid, 'stable'])) {
        modState = modState
            .setIn([TABLES, uuid, 'name'], '')
            .setIn([TABLES, uuid, 'open'], false);
    }

    return modState;
}

function managePayDivideTable(state, number, bar, cashbox, takeaway, discount, branch, paymentType,
                              sellTime, note, sellerId, items, vats) {
    let newState = state
        .set(ORDER_TO_PRINT, prepareOrderObject(
            sellerId,
            items,
            countTotalItemsPrice(items),
            vats,
            number,
            bar,
            cashbox,
            takeaway,
            discount,
            branch,
            paymentType,
            sellTime,
            null,
            null,
            false,
            note
        ));

    newState = manageFromList(newState);
    return clearDivedeLists(newState);
}

function createOrderToMap(state, number, bar, cashbox, takeaway, discount, branch, paymentType, sellTime, storno,
                          sellerId, items, vats) {
    return prepareOrderObject(
        sellerId,
        items,
        !storno ? state.get(TOTAL_PRICE_VAT) : state.getIn([RECEIPT_TO_STORNO, TOTAL_PRICE_VAT]),
        vats,
        number,
        bar,
        cashbox,
        takeaway,
        discount,
        branch,
        paymentType,
        sellTime,
        null,
        null,
        storno
    );
}

function canBeEdited(state) {
    if (state.get(MARKED_PRODUCT) === null) {
        return false;
    } else if (!state.get(MARKED_PRODUCT_TABLE) && state.get(SELECTED_PRODUCTS).size > 0) {
        return true;
    }

    return !!state.get(MARKED_PRODUCT_TABLE) && !!state.get(SHOW_TABLE_UUID) && state.getIn([TABLES, state.get(SHOW_TABLE_UUID), 'products']).size > 0;
}

function increaseProductHalfDivide(state) {
    let pcs;
    if (lastKeyTimeout(state)) {
        pcs = 0;
    } else {
        pcs = parseFloat(state.get(COUNT_TO_DIVIDE));
    }

    let newState = pcs < 9999
        ? state.set(COUNT_TO_DIVIDE, pcs + 0.5)
        : state;

    return newState.set(LAST_KEY_TIME, new Date().getTime());
}

function increaseProductHalf(state, id) {
    if (!canBeEdited(state)) {
        return state;
    }

    const route = getProductsPcsRoute(state, id);

    let pcs;
    if (lastKeyTimeout(state)) {
        pcs = 0;
    } else {
        pcs = parseFloat(state.getIn(route));
    }

    let newState = pcs < 9999
        ? state.setIn(route, pcs + 0.5)
        : state;

    newState = newState
        .set(LAST_NUM_KEY, 0.5)
        .set(LAST_KEY_TIME, new Date().getTime());

    return countTotalPriceSwitch(newState);
}

function increaseProduct(state, id) {
    if (!canBeEdited(state)) {
        return state;
    }

    const route = getProductsPcsRoute(state, id);

    const pcs = parseFloat(state.getIn(route));
    const newState = pcs < 9999
        ? state.updateIn(route, pcs => parseFloat(pcs) + 1)
        : state;

    return countTotalPriceSwitch(newState);
}

function getProductsRoute(state) {
    if (state.get(MARKED_PRODUCT_TABLE)) {
        return [TABLES, state.get(SHOW_TABLE_UUID), 'products'];
    } else {
        return [SELECTED_PRODUCTS];
    }
}

function getProductsPcsRoute(state, id) {
    if (typeof id === 'undefined') {
        id = state.get(MARKED_PRODUCT);
    }

    if (state.get(MARKED_PRODUCT_TABLE)) {
        return [TABLES, state.get(SHOW_TABLE_UUID), 'products', parseInt(id), 'pcs'];
    } else {
        return [SELECTED_PRODUCTS, parseInt(id), 'pcs'];
    }
}

function countTotalPriceSwitch(state) {
    if (state.get(MARKED_PRODUCT_TABLE)) {
        return countTableTotalPrice(state.get(SHOW_TABLE_UUID), state);
    } else {
        return countTotalPrice(state);
    }
}

function decreaseProduct(state, id) {
    if (!canBeEdited(state)) {
        return state;
    }
    if (typeof id === 'undefined') {
        id = state.get(MARKED_PRODUCT);
    }

    const route = getProductsPcsRoute(state);

    let newState = state.updateIn(route, pcs => parseFloat(pcs) - 1);
    const pcs = parseFloat(newState.getIn(route));
    newState = pcs <= 0
        ? removeProduct(newState, parseFloat(id))
        : newState;

    return countTotalPriceSwitch(newState);
}

function countTotalPrice(state) {
    const items = state.get(SELECTED_PRODUCTS);
    return state
        .set(TOTAL_PRICE_VAT, countTotalItemsPrice(items));
}

function countTableTotalPrice(uuid, state) {
    const items = state.getIn([TABLES, uuid, 'products']);
    return state
        .setIn([TABLES, uuid, 'totalPriceVat'], countTotalItemsPrice(items));
}

function removeProduct(state, id) {
    const route = getProductsRoute(state, id);

    let selectedId = null;
    const items = state.getIn(route);
    const item = items.get(id);
    if (!!item && items.size > 1) {
        const larger = items.filter(mi => mi.get('addTime') > item.get('addTime'));
        if (larger.size > 0) {
            selectedId = larger.sortBy(item => item.get('addTime')).first().get('id');
        } else {
            const smaller = items.filter(mi => mi.get('addTime') < item.get('addTime'));
            if (smaller.size > 0) {
                selectedId = smaller.sortBy(item => item.get('addTime')).reverse().first().get('id');
            }
        }
    }

    let newState = state.updateIn(route, items => items.remove(parseInt(id)));
    return newState.set(MARKED_PRODUCT, selectedId);
}

function addReceiptToSentBills(state) {
    let newState = state;
    if (newState.get(SENT_BILLS).size > 8) {
        const lastNumber = newState.get(SENT_BILLS).sortBy(r => r.get('number')).first().get('number');
        newState = newState.update(SENT_BILLS, orders => orders.remove(lastNumber));
    }

    return newState.update(SENT_BILLS, orders =>
        orders.set(newState.getIn([ORDER_TO_PRINT, 'number']), newState.get(ORDER_TO_PRINT)))
}

function selectStornoReceiptOnline(state, receipt) {
    let newState = state
        .set(RECEIPT_TO_STORNO, receipt)
        .set(SELECTED_PRODUCTS, Map())
        .set(TOTAL_PRICE_VAT, 0);

    return newState.update(SENT_BILLS, orders => orders.remove(parseInt(receipt.get('number'))));
}

function selectStornoReceipt(state, id) {
    const receiptNumber = parseInt(id);

    let newState = state
        .set(RECEIPT_TO_STORNO, state.getIn([SENT_BILLS, parseInt(id)]))
        .set(SELECTED_PRODUCTS, Map())
        .set(TOTAL_PRICE_VAT, 0);

    return newState.update(SENT_BILLS, orders => orders.remove(receiptNumber))
}

function resetCountToDivide(state) {
    return state.set(COUNT_TO_DIVIDE, 1)
}

function showTable(state, uuid) {
    return state
        .set(TABLE_LAST_STATE, state.getIn([TABLES, uuid, 'products']))
        .set(SHOW_TABLE_UUID, uuid);
}

function addTableListFunc(state, layoutId) {
    const tablesSize = state.get(COUNT_TABLE_PAGE);
    const maxTablePage = state.get(MAX_TABLE_PAGE);

    if (tablesSize < maxTablePage) {
        let modState = state;
        let layout;
        if (layoutId !== null && typeof layoutId !== 'undefined') {
            const layouts = modState.get(LAYOUTS);
            if (!!layouts) {
                const index = layouts.findIndex(obj => obj.get('id') === layoutId);
                if (index > -1) {
                    layout = layouts.get(index);
                }
            }
            modState = modState.set(LAYOUTS, Map());
        }
        const page = state.get(TABLE_PAGE);
        const wantAddPage = page + 1;

        // if list do prostřed, je třeba posunout od konce ostatní listy
        if (page < tablesSize) {
            let i = maxTablePage - 1;
            // kontrola jestli je co přesunout
            while (wantAddPage <= i) {
                const countPageTables = modState.get(TABLES).filter(t => t.get('page') === i).size;
                if (countPageTables > 0) {
                    modState = modState.update(TABLES, tables => tables.map(table => {
                        if (table.get('page') === i) {
                            return table.set('page', i + 1);
                        } else {
                            return table;
                        }
                    }));
                }
                i--;
            }
        }

        return modState
            .update(TABLES, tables => tables.merge(generateTables(wantAddPage, layout)))
            .set(TABLE_PAGE, wantAddPage)
            .set(COUNT_TABLE_PAGE, tablesSize + 1);
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/common/categories/reducer.js